/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { faPhoneAlt } from '@fortawesome/free-solid-svg-icons/faPhoneAlt'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useIntl } from 'react-intl'
import FormField, {
  FormTextFieldProps
} from '../../../../client/js/components/form/fields/FormField'
import PhoneInput from '../inputs/PhoneInput'

function PhoneField (props: FormTextFieldProps) {
  const { name = 'phone', ...others } = props
  const intl = useIntl()
  return (
    <FormField
      autoComplete="tel"
      label={intl.formatMessage({
        id: 'phone',
        defaultMessage: 'Téléphone'
      })}
      name={name}
      mask="000.00000000"
      placeholder="689.00000000"
      render={PhoneInput}
      type="tel"
      leftSection={(
        <FontAwesomeIcon
          fixedWidth
          icon={faPhoneAlt}
        />
      )}
      {...others}
    />
  )
}

export default PhoneField
